import { translate } from "app/filters/i18nFilter";
import {
    IntegrationStatusIndicator,
    IntegrationSpinner,
} from "app/pages/sales-intelligence/sub-modules/management/components/IntegrationStatusIndicator";

export const CrmIntegrationSyncLoading = () => {
    return (
        <IntegrationStatusIndicator
            tooltipText={translate("si.crm-integration.sync-loading.tooltip")}
            statusText={translate("si.crm-integration.sync-loading.title")}
            status="InProgress"
            icon={<IntegrationSpinner />}
            withIcon
        />
    );
};
